import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import { AmplitudeService } from '../services/AmplitudeService';
import { dataLayerHelper } from "../data/dataLayerModel";
import TagManager from "react-gtm-module";

export default function Finalizado(props: any) {

  const [fillCV, setFillCV] = useState<null | boolean>(null);
  const [typed, setTyped] = useState(false);

  useEffect(() => {
    TagManager.dataLayer(dataLayerHelper.pagina('finalizado', 'cadastro-usuario'));
    AmplitudeService.track('Register Done Screen')
  }, [])

  useEffect(() => {
    if (fillCV === true) {
      // TagManager.dataLayer(dataLayerHelper.pagina('finalizado-preencher', 'cadastro-usuario'));
      AmplitudeService.track('Fill CV Clicked');
      document.location = '#/deficiencia';
    }
    if (fillCV === false) {
      // TagManager.dataLayer(dataLayerHelper.pagina('finalizado-nao-preencher', 'cadastro-usuario'));
      AmplitudeService.track('Not Now Clicked');
      document.location = process.env.REACT_APP_CANDIDATE_APP_URL!;
    }
  }, [fillCV])


  return (
    <>
      <Header step={ 11 } total={ 11 } title="Cadastro finalizado" previous="#/termos" finished={ true }></Header>

      <div className="chat-container">

        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter.changeDelay(5).typeString(`Prontinho!<br />
                                                    <strong>Sua conta está criada!</strong><br/>
                                                    Agora vamos preencher seu currículo juntos para que as empresas possam saber mais sobre você?`)
                          .callFunction(() => {
                            setTyped(true)
                          })
                          .start();
                      } } />
                  </div>
                </div>

                { typed &&
                  <div className="gender-list">
                    <div className="gender-item">
                      <button className="btn btn-outline btn-full" onClick={ () => setFillCV(true) }>Preencher currículo</button>
                    </div>
                    <div className="gender-item">
                      <button className="btn btn-outline btn-full" onClick={ () => setFillCV(false) }>Agora não</button>
                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>


      </div>
    </>);
}
